import styled from '@emotion/styled';
export const PullRight = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
